import { flattenXgacFilter } from './xgacFilterDefinitions';
import { ScheduleTaskForm } from './types';

export const resolveScheduleTaskTemplateId = (
  taskTemplate: ScheduleTaskForm['taskTemplate'],
): string | null => {

  if (!taskTemplate) return null;
  if (typeof taskTemplate === 'string') return taskTemplate;
  return taskTemplate.id || null;

};

const normalizeIfScriptForComparison = (ifScript: ScheduleTaskForm['ifScript']) => {

  if (!ifScript?.name || ifScript.name === '') return null;
  if (ifScript.name === 'checkConfirmations') {

    return {
      name: 'checkConfirmations',
      meta: {
        requiredConfirmations: String(ifScript.meta?.requiredConfirmations ?? ''),
      },
    };

  }
  return null;

};

const normalizeMetaScriptForComparison = (metaScript: ScheduleTaskForm['metaScript']) => {

  if (!metaScript?.name) return null;

  if (metaScript.name === 'getAssets') {

    const xgacFilter = metaScript.meta?.xgacFilter || {};
    const flat = flattenXgacFilter(xgacFilter);
    const sortedKeys = Object.keys(flat).sort();
    const sortedFilter = Object.fromEntries(sortedKeys.map((key) => [key, flat[key]]));

    return {
      name: 'getAssets',
      filter: sortedFilter,
      max: xgacFilter.max ?? 0,
    };

  }

  return {
    name: metaScript.name,
    meta: metaScript.meta || {},
  };

};

const normalizeMetaDataForComparison = (metaData: ScheduleTaskForm['metaData']) => {

  if (!metaData || typeof metaData !== 'object') return null;

  const sortedKeys = Object.keys(metaData).sort();
  return Object.fromEntries(sortedKeys.map((key) => [key, metaData[key]]));

};

export const getScheduleTaskComparisonPayload = (task: ScheduleTaskForm) => ({

  taskTemplateId: resolveScheduleTaskTemplateId(task.taskTemplate),
  ifScript: normalizeIfScriptForComparison(task.ifScript),
  metaScript: normalizeMetaScriptForComparison(task.metaScript),
  metaData: normalizeMetaDataForComparison(task.metaData),

});

export const isScheduleTaskSameAsPrevious = (
  task: ScheduleTaskForm,
  previousTask: ScheduleTaskForm | undefined,
): boolean => {

  if (!previousTask) return false;

  return JSON.stringify(getScheduleTaskComparisonPayload(task))
    === JSON.stringify(getScheduleTaskComparisonPayload(previousTask));

};
